import React from 'react';
import ReactECharts from 'echarts-for-react';
import SafeIcon from '../../common/SafeIcon';

const PipelineChart = () => {
  const option = {
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      right: '5%',
      top: 'center',
      icon: 'circle',
      textStyle: { color: '#6b7280' }
    },
    series: [
      {
        name: 'Application Pipeline',
        type: 'pie',
        radius: ['45%', '70%'],
        center: ['35%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 6,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: { show: false },
        data: [
          { value: 450, name: 'Pending', itemStyle: { color: '#f59e0b' } },
          { value: 320, name: 'Reviewed', itemStyle: { color: '#00AEEF' } },
          { value: 180, name: 'Shortlisted', itemStyle: { color: '#11469A' } },
          { value: 240, name: 'Rejected', itemStyle: { color: '#ef4444' } },
          { value: 120, name: 'Accepted', itemStyle: { color: '#10b981' } }
        ]
      }
    ]
  };

  return (
    <div className="card p-6 h-full">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h3 className="text-lg font-bold text-gray-800">Application Pipeline</h3>
          <p className="text-sm text-gray-500">Current candidate status distribution</p>
        </div>
        <button className="p-2 text-gray-400 hover:text-brand-primary rounded-lg hover:bg-gray-50 transition-colors">
          <SafeIcon name="MoreVertical" size={20} />
        </button>
      </div>
      <div className="h-[280px]">
        <ReactECharts option={option} style={{ height: '100%', width: '100%' }} />
      </div>
    </div>
  );
};

export default PipelineChart;